<template>
  <div class="col-md-4  pb-3">
    <div class="card" style="z-index: 0">
      <div class="cover" :class="[goal.picture && 'cover-custom-img']" @click="openContributeModal">
        <img v-if="goal.picture" class="card-img-top"
             v-show="imageLoaded"
             @load="imageLoaded = true"
             alt=""
             :src="goal.picture.picture_thumb_module">

        <img class="card-img-top"
             v-show="!imageLoaded"
             alt=""
             src="@/assets/app/media/img/misc/placeholder.png">
      </div>
      <div class="card-body">
        <h6 class="card-title ellipsis" v-encode="goal.name" @click="openContributeModal"></h6>
        <div class="card-text">
          <div class="row m-row--no-padding align-items-center">
            <div class="col-xl-8">
              <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-ls"
                     role="progressbar"
                     :aria-valuenow="progressBarPercent" aria-valuemin="0" aria-valuemax="100"
                     :style="`width: ${progressBarPercent}%`"></div>
              </div>
            </div>
            <div class="col-xl-4 m--align-right">
              <span class="m--font-boldest font-ls">{{goal.points}} {{ pointsSymbol }}</span>
            </div>
          </div>
          <span v-if="goal.points !== goal.points_contributed" class="m-widget24__change">
            {{$t('Missing')}} {{ missingPoints }} {{pointsSymbol}}
					</span>
          <span v-else class="m-widget24__change">
            {{$t('Goal achieved')}}
					</span>
          <div class="m-widget19__action mt-4 d-flex justify-content-center">
            <button v-if="missingPoints > 0"
                @click="openContributeModal"
                type="button" class="btn m-btn--pill m-btn m-btn--custom btn-outline-light btn-ls m-btn--hover-ls">
              {{$t('Support')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="isContributeModalOpen" header-class="border-bottom-0 p-0 m-0 mr-1"
             lazy centered size="lg"
             :cancel-title="$t('Cancel')"
             @hidden="donatePoints = 0"
             @ok="donate"
             :ok-title="!isGoalReached ? $t('Support') : $t('Close')"
             :ok-only="isGoalReached"
             :ok-disabled="parseFloat(donatePoints) === 0 && !isGoalReached"
             ok-variant="ls">
      <template v-slot:modal-header="{ close }">
        <button type="button" aria-label="Close" class="close mt-1 mb-0 mr-3" @click="close">×</button>
      </template>
      <div class="row">
        <div v-if="goal.picture" class="col-lg-5 col-12">
          <img :src="goal.picture.picture" class="img-fluid rounded" alt="">
        </div>
        <div class="col d-flex flex-column mt-4 mt-lg-0">
          <h5 v-encode="goal.name"></h5>
          <div v-if="goal.description" v-html="goal.description"></div>
          <div v-if="!isGoalReached" class="mt-4 mt-lg-auto mb-auto">
            <div class="range-container">
              <donate-range ref="range" v-model="donatePoints"
                            :points-left="missingPoints"/>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isContributedModalOpen" lazy hide-footer hide-header centered size="lg">
      <img src="@/assets/app/media/img/icons/close.png" @click="isContributedModalOpen = false" class="close" alt="X">
      <div v-html="contributedMessage"></div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
  import Encode from "@/directives/encode";
  import DonateRange from "./DonateRange";
  import ClickOutside from 'vue-click-outside'

  export default {
    name: "Goal",
    components: {DonateRange},
    props: {
      goal: Object
    },
    directives: {
      Encode,
      ClickOutside,
    },
    data() {
      return {
        imageLoaded: false,
        isContributeModalOpen: false,
        isContributedModalOpen: false,
        donatePoints: "0",
        contributedMessage: ''
      }
    },
    methods: {
      ...mapActions([
        'setOrder',
        'setDigitalOrder',
      ]),
      openContributeModal() {
        this.isContributeModalOpen = true;
      },
      previewImg() {
        if (this.goal.picture) {
          this.$imgPreview({
            img: this.goal.picture.picture,
          })
        }
      },
      donate() {
        if (this.isGoalReached) {
          return;
        }

        this.$http.post(`goals/donate/${this.goal.id}`, {points: parseFloat(this.donatePoints)})
          .then((r) => {
            if (r.data.success) {
              this.contributedMessage = r.data.message;
              this.isContributedModalOpen = true;
            } else {
              this.$notify.danger(r.data.message);
            }

            this.$emit('refresh');
          });
      }
    },
    computed: {
      ...mapState({
        pointsConfig: state => state.settings.points,
        pointsSymbol() {
          return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
        }
      }),
      progressBarPercent() {
        return Math.ceil((parseFloat(this.goal.points_contributed) / parseFloat(this.goal.points)) * 100)
      },
      missingPoints() {
        const missing = parseFloat(this.goal.points) - parseFloat(this.goal.points_contributed);

        if (missing <= 0) {
          return 0;
        }

        if (missing === Math.floor(missing)) {
          return Math.floor(missing);
        }

        return missing.toFixed(2);
      },
      isGoalReached() {
        return this.missingPoints === 0;
      }
    }
  }
</script>

<style scoped>
  .shadow {
    background-color: green;
    -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-title {
    cursor: pointer;
  }

  .cover {
    position: relative; /* Not required now */
    float: left;
    -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
    box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  }

  .cover img {
    display: block;
    position: relative;
    z-index: -1;
  }

  .cover-custom-img:hover {
    background: rgba(1, 1, 1, 0.1);
    cursor: pointer;
    position: relative;
  }

  .cover-custom-img:hover:before {
    cursor: pointer;
    font-family: "Font Awesome 5 Free", serif;
    font-weight: 900;
    font-size: 60px;
    content: "\F00E";
    color: white;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 40px;
    height: 80px;
  }

  .hidden {
    display: none !important;
  }

  .close {
    width: 23px;
    height: 23px;
    margin-top: -15px;
    margin-right: -5px;
  }
</style>
